import browser from '@openclassrooms/utils/browser';

export default function jsonConfig(scriptId) {
  const scriptTag =
    typeof scriptId === 'string' ? browser.document.getElementById(scriptId) : scriptId;

  if (!scriptTag) {
    return {};
  }

  return JSON.parse(scriptTag.textContent);
}
